import React, { useCallback } from 'react'
import styled from 'styled-components'
import { IconClose } from '@loadsmart/icons'
import { useDispatch, useSelector } from 'react-redux'

import { deleteMessage } from 'features/message/actions'
import { messageListSelector } from 'features/message/selectors'
import Alert from 'components/Alert'
import { UnstyledButton } from 'components/Button'

const Bold = styled.div`
  font-weight: 700;
  margin-right: 10px;
`
const Actions = styled.div`
  align-self: flex-end;
  flex-grow: 3;
  text-align: right;
`

export default function MessageCenter() {
  const dispatch = useDispatch()
  const messages = useSelector(messageListSelector)

  const removeMessage = useCallback(
    (id: string) => {
      dispatch(deleteMessage(id))
    },
    [dispatch]
  )

  return (
    <>
      {messages.map((message) => (
        <Alert key={message.id} type={message.type}>
          <Bold>{message.message}</Bold>
          {message.description && <div>{message.description}</div>}
          <Actions>
            <UnstyledButton onClick={() => removeMessage(message.id)}>
              <IconClose width={14} height={14} />
            </UnstyledButton>
          </Actions>
        </Alert>
      ))}
    </>
  )
}
